module.exports = __webpack_public_path__ + "static/media/picto-sharing-blue.072160b8.svg";